import {closeAllDialogs} from './base';
import DialogModal from './dialog-base/base';

document.addEventListener('DOMContentLoaded', () => {
    const settingsMaintenanceModal = {
        autoOpen: true,
        stopAutoOpenSessionKey: 'maintenance_stop',
        callbackByOpen: () => {
            if (!sessionStorage.getItem('maintenance_stop')) {
                sessionStorage.setItem('maintenance_stop', 'Y');
            }
        },
    };

    new DialogModal({
        dialogSelector: '#maintenanceForm',
        settings: settingsMaintenanceModal,
    });

    const settingErrorModal = {
        callbackByOpen: () => {
            closeAllDialogs('requestErrorForm');
        },
    };

    new DialogModal({
        dialogSelector: '#requestErrorForm',
        dialogOpenTrigger: '[data-entity="maintenance-trigger"]',
        settings: settingErrorModal,
    });
});
